export function getCardholderName(paymentOption, billingAddress) {
    if (paymentOption?.card_holder) {
        if (paymentOption.card_holder.name) {
            return paymentOption.card_holder.name
        } else if (paymentOption.card_holder.first_name && paymentOption.card_holder.last_name) {
            return `${paymentOption.card_holder.first_name} ${paymentOption.card_holder.last_name}`
        }
    }
    if (billingAddress?.firstName && billingAddress.lastName) {
        return `${billingAddress.firstName} ${billingAddress.lastName}`
    }
    return ''
}